import type { ContentSource } from '../../hooks/useContentTasks'

interface SourcesListProps {
  sources: ContentSource[]
  /** Optional class for the wrapper (e.g. for print/reading layout). */
  className?: string
}

/**
 * Renders a numbered list of sources with anchors for citation links (#fuente-N).
 * Visible in reading mode and in print when used in the main content area.
 */
export function SourcesList({ sources, className = '' }: SourcesListProps) {
  if (!sources?.length) return null

  return (
    <section
      className={`mt-6 pt-6 border-t border-slate-200 ${className}`}
      aria-label="Fuentes"
    >
      <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-3">
        Fuentes
      </h3>
      <ol className="list-decimal pl-6 space-y-2 text-sm text-slate-700">
        {sources.map((src) => (
          <li key={src.id} id={`fuente-${src.id}`} className="leading-relaxed">
            <a
              href={src.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-emerald-600 hover:text-emerald-700 underline decoration-emerald-300 hover:decoration-emerald-500 transition-colors"
            >
              {src.title}
            </a>
            {src.domain && (
              <span className="text-slate-500 ml-1.5 text-xs">({src.domain})</span>
            )}
            {src.snippet && (
              <p className="mt-0.5 text-slate-500 text-xs line-clamp-2">{src.snippet}</p>
            )}
          </li>
        ))}
      </ol>
    </section>
  )
}
